import React, { useState, useEffect } from "react";
import "../styles/ResourceAllocationGrid.css";

const ResourceAllocationGrid = ({ formData, highlightedCells = new Set() }) => {
    

  

    if (!formData.resourceAllocationGrid || formData.resourceAllocationGrid.length === 0) {
        return <p>No data available</p>;
    }

    

    return (
        <div className="allocation-container">
            <table className="allocation-table">
                <thead>
                    <tr>
                        <th>{formData.implementationType === 'Agile' ? 'Sprints' : 'Milestones'} / Resource</th>
                        {formData.resourceTable.map(resource => (
                            <th key={resource.id}>{resource.alias}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {formData.resourceAllocationGrid.map((sprintRow, sprintIndex) => (
                        <tr key={sprintIndex}>
                            <td className="sprint-cell">{sprintIndex + 1}. {sprintRow.sprint.name}</td>
                            {formData.resourceTable.map(resource => {
                                const allocation = sprintRow.allocations[resource.id] || {};
                                const cellKey = `${sprintIndex}-${resource.id}`;
                                const isHighlighted = highlightedCells.has(cellKey);

                                return (
                                    <td
                                        key={resource.id}
                                        className={`allocation-cell ${isHighlighted ? "highlight" : ""}`}
                                    >
                                        <span className="percentage">{allocation.allocationPercentage?.toFixed(1) || 0}%</span>
                                        <br />
                                        <span className="hours">{allocation.allocatedHours?.toFixed(1) || 0} hrs</span>
                                    </td>
                                );
                            })}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default ResourceAllocationGrid;
